<template>
  <div class="my-dropdown" tabindex="-1" ref="dropdown">
    <div class="my-dropdown-title" @click="handleClick">
      <slot name="title"></slot>
    </div>
    <transition name="el-fade-in-linear" v-if="animation === 'fade'">
      <div class="my-dropdown-content" v-show="show">
        <slot name="content"></slot>
      </div>
    </transition>
    <el-collapse-transition v-if="animation === 'collapse'">
      <div class="my-dropdown-content" v-show="show">
        <slot name="content"></slot>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import TheHeading from './TheHeading.vue'
export default {
  name: 'MyDropdown',
  components: { TheHeading },
  props: {
    autohidden: { type: Boolean, default: false },
    animation: { type: String, default: 'collapse' }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    handleClick () {
      this.show = !this.show
    },
    handleBlur () {
      this.show = false
    }
  },
  mounted () {
    if (this.autohidden) {
      this.hide = document.addEventListener('click', e => {
        this.$nextTick(() => {
          if (!this.$el.contains(e.target)) {
            this.show = false
          }
        })
        // let box = this.$refs.dropdown
        // if (!box.contains(e.target)) {
        //   this.show = false
        // }
      })
    }
  },
  beforeDestroy () {
    if (this.autohidden) {
      document.removeEventListener('click', this.hide)
    }
  }
}
</script>

<style scoped>
.my-dropdown {
  position: relative;
  display: inline-block;
}

.my-dropdown-title {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.my-dropdown-content {
  width: 100%;
  background-color: #f1f1f1;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/MyDropdown.vue